
import { Vue, Component } from 'vue-property-decorator';
import Pagination from '@/components/board/pagination.vue';
import { searchCompanyIR } from '@/api/company';
import { ICompanySearch } from '@/types/company';
import { UserModule } from '@/store/user';
import { downloadFileAsBlob } from '@/api/attachedFile';

@Component({
  name: 'IrDataList',
  components: {
    Pagination,
  },
})
export default class extends Vue {
  private readonly SESSION_KEY = 'IR_DATA_STATE';

  private listQuery: any = {
    page: 0,
    size: 9,
    searchValue: '',
    sort: 'progress',
    progress: 0,
    categories: [],
    target: '',
    categories2: '',
    startDate: '',
    endDate: '',
  };

  private companyList: any = [];

  private totalElements = 0;

  private totalPages = 1;

  get imagePath() {
    return `${process.env.VUE_APP_COMMON_API}/attached-file`;
  }

  private fetchCompanies() {
    let apiPage = this.listQuery.page;
    if (apiPage < 0) apiPage = 0;

    const searchParams: ICompanySearch = {
      page: apiPage,
      size: this.listQuery.size,
      searchValue: this.listQuery.searchValue,
    };

    searchCompanyIR(searchParams)
      .then(async (res) => {
        this.companyList = res.data.content;
        this.totalElements = res.data.totalElements;
        this.totalPages = res.data.totalPages;
      })
      .catch((error) => {
        console.error('IR 기업 검색 실패:', error);
      });
  }

  mounted() {
    this.init();
  }

  checkAuthAndNavigate(uid: string): void {
    if (!UserModule.token) {
      alert('로그인이 필요한 서비스입니다.');
    } else {
      const state = {
        listQuery: this.listQuery,
      };
      sessionStorage.setItem(this.SESSION_KEY, JSON.stringify(state));

      this.$router.push({
        name: 'IrdataDetail',
        params: { irdataUid: uid },
      });
    }
  }

  private async init() {
    const savedState = sessionStorage.getItem(this.SESSION_KEY);

    // 데이터를 읽은 후 즉시 세션에서 삭제 (다른 메뉴 이동 시 초기화를 위함)
    sessionStorage.removeItem(this.SESSION_KEY);

    if (savedState) {
      // 상세페이지에서 돌아온 경우 복구
      const parsed = JSON.parse(savedState);
      this.listQuery = parsed.listQuery;
      this.fetchCompanies();
    } else {
      // 다른 메뉴에서 진입 시 기본값 초기화
      this.listQuery.page = 0;
      this.listQuery.searchValue = '';
      this.fetchCompanies();
    }
  }

  private handleSearch() {
    this.listQuery.page = 0;
    this.fetchCompanies();
  }

  private handleChangePage(page: number) {
    this.listQuery.page = page;
    this.fetchCompanies();
  }

  private searchReset() {
    sessionStorage.removeItem(this.SESSION_KEY);
    this.listQuery.searchValue = '';
    this.listQuery.page = 0;
    this.fetchCompanies();
  }

  private getThumnail(inputValue: string) {
    if (inputValue.startsWith('http')) return inputValue;
    return `${this.imagePath}/${inputValue}`;
  }

  private getNumber(index: number) {
    const totalSize = (this.listQuery.page - 1) * this.listQuery.size;
    return this.totalElements - totalSize - index;
  }
}
